<template>
  <div class="">
    <div class="lg:flex md:flex gap-5 lg:px-10 md:px-10 px-5">
      <div class="lg:w-1/2 md:w-1/2 w-full">
        <img
          src="https://nimbus-server-01.brained.in/nimbus-server-01/caregiversaathi/CG/1.jpg"
          class="w-full custborderradius aboutusimg md:block lg:block"
          alt="swiper-img"
        />
      </div>
      <div class="lg:w-1/2 md:w-1/2 w-full lg:pt-0 md:pt-0 pt-5">
        <div class="lg:w-5/6 md:w-5/6 w-full w-full mr-auto">
          <p class="subtitle lh32px sm-lh26 sm-fsize13">
            The HeArt of Care is an International Alliance of organisations
            united in their efforts to promote awareness of the vital role
            played by Caregivers in our communities. Caregiver Saathi is proud
            to present this endeavour to our Caregiver community. With The HeArt
            of Care project, we aim to pay tribute to those who selflessly care
            for others, and we warmly invite Caregivers to share their art in
            the form of photographs, poetry and videos with us. We hope to
            capture the essence of care and instill a fresh perspective on the
            dignity, compassion, and joy of caregiving. These contributions will
            serve as a testament to the complexities of caregiving and inspire a
            broader appreciation for the remarkable resilience and commitment of
            Caregivers.
            <br />
            To gain inspiration and insights into our collaborative endeavours,
            we encourage you to explore the Gallery page. We believe that the
            images, poetry, and videos will ignite your creativity and provide
            valuable ideas for the images you may consider submitting. Please
            use the Share Your Work page to upload your artwork/image/poetry and
            help us foster greater awareness of Caregiver’s significance in
            society.
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  methods: {
    handleClick(name) {
      this.$router.push({ name: name });
    },
  },
};
</script>

<style>
@media (max-width: 640px) {
  .aboutusimg {
    top: 595px;
    width: 342px;
    left: 1rem;
  }
}
</style>
